import InsightsOutlined from '@mui/icons-material/InsightsOutlined';
import Box from '@mui/material/Box';
import type { ReactNode } from 'react';
import trophyUrl from '../../assets/signals/trophy.svg';
import { iconFor } from '../workflows/workflowIcons.js';

// Figma workflow tile (nodes 12055:65097, 11772:77162): 40px, radius 11.25, purple gradient.
const TILE_SIZE = 40;
const TILE_GRADIENT = 'linear-gradient(135deg, #FAEEFF 3.125%, #E6CBF6 100%)';

// The Figma glyphs keep their own box; the insets place it inside the tile exactly as drawn.
const FIGMA_GLYPHS: Record<string, FigmaGlyph> = {
  trophy: {
    src: trophyUrl,
    width: 23.4375,
    height: 18.75,
    inset: { left: '21.88%', right: '19.53%', top: '28.13%', bottom: '25%' },
  },
};

interface FigmaGlyph {
  src: string;
  width: number;
  height: number;
  inset: { left: string; right: string; top: string; bottom: string };
}

export function SignalIcon({ icon }: { icon: string }): ReactNode {
  const glyph = FIGMA_GLYPHS[icon];
  const Fallback = iconFor(icon, InsightsOutlined);
  return (
    <Box
      aria-hidden="true"
      data-testid="signal-icon"
      data-icon={glyph === undefined ? 'fallback' : icon}
      sx={{
        position: 'relative',
        width: TILE_SIZE,
        height: TILE_SIZE,
        flexShrink: 0,
        borderRadius: '11.25px',
        background: TILE_GRADIENT,
        display: 'grid',
        placeItems: 'center',
        color: 'attribute.product.main',
      }}
    >
      {glyph === undefined ? (
        <Fallback sx={{ fontSize: 20 }} />
      ) : (
        <Box
          component="img"
          src={glyph.src}
          alt=""
          width={glyph.width}
          height={glyph.height}
          sx={{ position: 'absolute', ...glyph.inset, display: 'block' }}
        />
      )}
    </Box>
  );
}
